/**
 * The loading screen's exit, ported from the Claude Design canvas
 * ("Setbox Home", 2026-09-16).
 *
 * The overlay is in the markup and hidden by this script, never the other way
 * round. That order matters: if the script fails to load or run, the visitor
 * gets the page rather than a black rectangle forever.
 *
 * Two guarantees, and the second is why the cap exists at all:
 *   - it stays up for at least the configured minimum, so the animation is not
 *     a flash on a warm cache;
 *   - it comes down no later than 4s after DOM ready whatever else happens,
 *     because a stalled image must not be able to hold the page hostage.
 */
(() => {
  const CAP = 4000;

  const overlay = document.querySelector('[data-setbox-preloader]');
  if (!overlay) return;

  const minimum = Number(overlay.dataset.min) || 0;
  const started = Date.now();
  let done = false;

  const hide = () => {
    if (done) return;
    done = true;
    overlay.setAttribute('data-hidden', '');
    // Removed after the fade so it cannot swallow a click, and so the
    // animation stops costing anything.
    overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
    setTimeout(() => overlay.remove(), 1200);
  };

  const finish = () => setTimeout(hide, Math.max(0, minimum - (Date.now() - started)));

  // The hero image is what the visitor is actually waiting for; `load` on the
  // window would also wait for every lazy clip below the fold.
  const hero = document.querySelector('.setbox-hero__img, .setbox-hero__media img');
  if (hero instanceof HTMLImageElement && !hero.complete) {
    hero.addEventListener('load', finish, { once: true });
    hero.addEventListener('error', finish, { once: true });
  } else {
    finish();
  }

  window.addEventListener('load', finish, { once: true });
  setTimeout(hide, CAP);
})();
